<template>
    <div class="main-content">
        <section class="non-app-page-width setting-profile-popup mfp-hide popup-save-document">
<!--            <a @click="$router.go(-1)" class="profile-edit-close-btn">-->
<!--                <img src="/assets/img/close-icon.svg"/>-->
<!--            </a>-->
            <div class="setting-profile-wrapper">
                <div class="save-document-form">
                    <h2>Select a Team to Launch</h2>
                    <p>you will switch to the selected Team space</p>
                    <a class="team-select"  @click.prevent="switchTeam(team)" v-for="team in teams" :key="team.name">
                        <span class="team-name">{{ team.name }}</span>
                        <button class="btn btn-sm-primary full-rounded team-btn" v-if="!team.locked">Select</button>
                        <button class="btn btn-sm-primary full-rounded team-btn" v-else >Team Locked</button>
                    </a>
                    <p class="mt-5">Or</p>
                    <router-link :to="{ name: 'Create Team' }" class="btn btn-primary mr-0 mt-3 mx-auto" >create a new team</router-link>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ApiService from "../../api/api.service";

export default {
    name: "SwitchTeam",
    data() {
        return {
            current_team_id: null,
            teams: [],
        }
    },
    mounted() {
        this.getTeams();
    },
    methods: {
        switchTeam(team) {
            if(!team.locked) {
                ApiService.setHeader();
                ApiService.post('/api/teams/switch', { team_id: team.id})
                    .then(({data}) => {
                        ApiService.setHeader();
                        ApiService.get('/api/user').then(({data}) => {
                            this.user = data;
                            window.localStorage.setItem('user', JSON.stringify(data));

                            if(this.user.team_id && this.user.team_role == 'member') {
                                window.location.href = '/documents';
                                return;
                            } else {
                                window.location.href = '/teams/manage';
                                return;
                            }

                        }).catch(error => {
                            throw new Error('failed to load user');
                        });


                    })
                    .catch();
            }

        },
        getTeams() {
            ApiService.setHeader();
            ApiService.get('/api/teams')
                .then(({data}) => {
                    this.teams = data.teams;
                    if(!this.teams.length) {
                        this.$router.push({ name : 'Create Team Intro' })
                    }
                    this.current_team_id = data.current_team_id;
                })
                .catch((response) => {
                    console.log(response);
                })
        },


    }
}
</script>

<style scoped>

a.team-select {
    border: 1px solid #DFDFDF;
    border-radius: 4px;
    padding: 25px 40px;
    display: flex;
    width: 418px;
    justify-content: space-between;
    margin: 10px auto;
}

a.team-select:hover {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

a.team-select .team-name {
    float: left;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #16181F;
    text-align: left;
}

a.team-select button {
    float: right;
    height: fit-content;
}

button.full-rounded {
    border-radius: 20px;
}

</style>
